function renderWishlistCounter() {
  var elements = document.querySelectorAll(".swym-wish-counter");
  for (var i = 0; i < elements.length; i++) {
    if (window._swat.renderWishlistCount) {
      window._swat.renderWishlistCount(elements[i], function(cnt, elem) {
        console.log("debug - renderWishlistCount", cnt, elem);
      }
    )};
  }
}
if (!window._swat) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(renderWishlistCounter);
} else {
  renderWishlistCounter();
}

window.addEventListener("resize", renderWishlistCounter);

// document.addEventListener('DOMContentLoaded', function() {
//     setTimeout(function() {
//       const buttons = document.querySelectorAll('.btn-add-to-cart span.btn-label');
//       const buynowbtn = document.querySelector('.dynamic-checkout');
//       let addToQuoteExists = false;
  
//       buttons.forEach(function(button) {
//           if (button.innerHTML == 'Enquire') {
//               addToQuoteExists = true;
//           }
//       });
  
//       if (addToQuoteExists) {
//         buttons.forEach(function(button) {
//             if (button.innerHTML == 'Add to cart') {
//                 let btnAddToCart = button.parentElement;
//                 if (btnAddToCart) {
//                     btnAddToCart.style.display = 'none';
//                     buynowbtn.style.display = 'none';
//                 }
//             }
//         });
//       }
//     }, 2000);
// });

// $(document).ready(function(){
//   $('.banner-slider-selector').slick({
//     dots: true,
//     arrows: false,
//     infinite: true,
//     vertical: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     adaptiveHeight: true
//   });

//   let scrollFlag = false;

//   const backgroundImages = [
//     'https://cdn.shopify.com/s/files/1/0657/1094/8503/files/Frame_11.png?v=1727244652',
//     'https://cdn.shopify.com/s/files/1/0657/1094/8503/files/Banner_2.png?v=1727675233',
//     'https://cdn.shopify.com/s/files/1/0657/1094/8503/files/Banner_3.png?v=1727675233'
//   ];

//   function updateBackgroundImage(index) {
//     const backgroundImage = backgroundImages[index];

//     if (backgroundImage) {
//       $('.custom-banner-section').css('background-image', `url(${backgroundImage})`);
//     }
//   }

//   updateBackgroundImage($('.banner-slider-selector').slick('slickCurrentSlide'));

//   $('.banner-slider-selector').on('wheel', function(event) {
//     event.preventDefault();
//     event.stopPropagation();
    
//     if (scrollFlag) return;
//     scrollFlag = true;

//     if (event.originalEvent.deltaY < 0) {
//         $(this).slick('slickPrev');
//     } else {
//         $(this).slick('slickNext');
//     }

//     const currentSlide = $(this).slick('slickCurrentSlide');
//     updateBackgroundImage(currentSlide);

//     setTimeout(() => scrollFlag = false, 500);
//   });

//   $('.banner-slider-selector').on('afterChange', function(event, slick, currentSlide) {
//     updateBackgroundImage(currentSlide);
//   });
// });


document.addEventListener('DOMContentLoaded', function() {
  function updateActiveItems() {
    if (window.innerWidth >= 769) {
      setTimeout(function() {
        const allItems = document.querySelectorAll('.home-testimonials .card_section-item');
        const activeItems = document.querySelectorAll('.home-testimonials .card_section-item.tns-slide-active');

        allItems.forEach(item => {
          item.style.opacity = '0.5';
          item.style.borderLeft = '';
          item.style.borderRight = '';
        });

        if (activeItems.length > 0) {
          const midActive = activeItems[1];
          
          if (midActive) {
            midActive.style.opacity = '1';
            midActive.style.borderLeft = '1px solid #FF5C20';
            midActive.style.borderRight = '1px solid #FF5C20';
          }

        }
      }, 500);
    }
  }

  updateActiveItems();

  const nextButton = document.querySelector('.home-testimonials .js-next-button');
  const prevButton = document.querySelector('.home-testimonials .js-prev-button');

  if (nextButton && prevButton) {
    nextButton.addEventListener('click', updateActiveItems);
    prevButton.addEventListener('click', updateActiveItems);
  }
});

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const button = document.querySelector('.sp-com-w-btn:not(#compare-widget-section .sp-com-w-btn)');
      console.log('Button:', button);
      if (button) {
        button.addEventListener('click', function() {
          window.location.href = 'https://ezzy-vision.myshopify.com/apps/equate-product-comparison';
        });
      }
    
      const element = document.querySelector('.sp-com-w:not(#compare-widget-section .sp-com-w)');
      console.log('Element:', element);
      if (element) {
        element.id = 'custom-sp-com-w';
      }
    }, 2500);
});

document.addEventListener('DOMContentLoaded', function() {
  const descriptionElement = document.querySelector('.product-description');

  if(descriptionElement){
    let descriptionHTML = descriptionElement.innerHTML;
    
    descriptionHTML = descriptionHTML.replace(/\\n/g, '<br>');
    descriptionHTML = descriptionHTML.replace("Material Number", 'Part Number');
    
    descriptionElement.innerHTML = descriptionHTML;
  }
});

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const descriptionElements = document.querySelectorAll('.sp-comp-t-row div');
    
    descriptionElements.forEach(function(descriptionElement) {
      let descriptionHTML = descriptionElement.innerHTML;
      
      descriptionHTML = descriptionHTML.replace(/\\n/g, '<br>');
      descriptionHTML = descriptionHTML.replace("Material Number", 'Part Number');
      
      descriptionElement.innerHTML = descriptionHTML;
    });
  }, 4000);
});

document.addEventListener("DOMContentLoaded", function() {
    const buyItNowButton = document.querySelector(".shopify-payment-button__button");
    if (buyItNowButton) {
        buyItNowButton.textContent = "Buy It Now";
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const aside = document.querySelector('#shopify-section-collection-sidebar');

    if (aside) {
        const isEmpty = Array.from(aside.childNodes).every(node => 
            (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'STYLE') ||
            (node.nodeType === Node.TEXT_NODE && !node.textContent.trim())
        );
        
        if (isEmpty) {
            aside.classList.add('empty-aside');
        }
    }
});


document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
      const imgElements = document.querySelectorAll(".grfq-product-image");

      imgElements.forEach(img => {
          if (img.getAttribute("src") === "undefined") {
              img.setAttribute("src", "//ezzy-vision.myshopify.com/cdn/shop/t/2/assets/default-image.png");
          }
      });
    }, 1000);
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const megaMenuTrigger = document.querySelector('.header-nav .menu-item.mega-menu');

    if (megaMenuTrigger) {
      megaMenuTrigger.addEventListener('mouseenter', () => {
        const menuItems = document.querySelectorAll('.mega-menu-list .menu-list.child-list .menu-item');

        function isInRight30Percent(element) {
          const viewportWidth = window.innerWidth;
          const elementXPosition = element.getBoundingClientRect().left;
          const right30PercentStart = viewportWidth * 0.7;
          return elementXPosition >= right30PercentStart;
        }

        function isInBottom30Percent(element) {
          const viewportHeight = window.innerHeight;
          const elementYPosition = element.getBoundingClientRect().top;
          const bottom30PercentStart = viewportHeight * 0.65;
          return elementYPosition >= bottom30PercentStart;
        }

        menuItems.forEach((item) => {
          item.addEventListener('mouseenter', () => {
            const grandChildList = item.querySelector('.menu-list.grand-child-list');

            if (grandChildList) {
              if (isInBottom30Percent(item)) {
                grandChildList.style.top = 'unset';
                grandChildList.style.bottom = '0';
              } else {
                grandChildList.style.top = '0';
                grandChildList.style.bottom = 'unset';
              }

              if (isInRight30Percent(item)) {
                grandChildList.style.left = '-200px';
              } else {
                grandChildList.style.left = '200px';
              }
            }
          });
        });
      });
    }
  }, 1000);
});


document.addEventListener("DOMContentLoaded", function() {
    if (window.innerWidth <= 767) {
        var mobileOnlyContainer = document.getElementById("mobile-only-container");
        if (mobileOnlyContainer) {
            mobileOnlyContainer.innerHTML = `
                <div class='buckscc-currency-box'></div>
            `;
        }
    }
});


window.addEventListener("resize", function() {
    var mobileOnlyContainer = document.getElementById("mobile-only-container");
    if (window.innerWidth <= 767 && !mobileOnlyContainer.innerHTML) {
        mobileOnlyContainer.innerHTML = `
            <div class='buckscc-currency-box'></div>
        `;
    } else if (window.innerWidth > 767) {
        mobileOnlyContainer.innerHTML = "";
    }
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".template-collection .description-content img").forEach(img => {
        if (img.hasAttribute("src")) {
            img.src = img.src.replace("cdn-hkecp.nitrocdn.com/XbXVKHXPooyWdKYCIaeQBGphzqSeGRcW/assets/images/optimized/rev-70732b6/", "");
        }
    });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.template-collection .description-content img').forEach((img) => {
    const oldSrc = img.getAttribute('src') || img.getAttribute('data-src');
    if (oldSrc) {
      const fileName = oldSrc.substring(oldSrc.lastIndexOf('/') + 1);
      const newBaseURL = 'https://cdn.shopify.com/s/files/1/0657/1094/8503/files/';
      img.setAttribute('src', newBaseURL + fileName);
      if (img.hasAttribute('data-src')) {
        img.setAttribute('data-src', newBaseURL + fileName);
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const newBaseURL = 'https://cdn.shopify.com/s/files/1/0657/1094/8503/files/';

  document.querySelectorAll('.template-collection .description-content img').forEach((img) => {
    const oldSrc = img.getAttribute('src');
    if (oldSrc) {
      const fileName = oldSrc.substring(oldSrc.lastIndexOf('/') + 1);
      const newURL = newBaseURL + fileName;

      img.setAttribute('src', newURL);
      img.setAttribute('data-src', newURL);
      img.setAttribute('srcset', newURL);
      img.setAttribute('nitro-lazy-src', newURL);
      img.setAttribute('nitro-lazy-srcset', newURL);
    }
  });

  document.querySelectorAll('.template-collection .description-content a').forEach((anchor) => {
    const href = anchor.getAttribute('href');
    if (href && href.match(/\.pdf$/i)) {
      const fileName = href.substring(href.lastIndexOf('/') + 1);
      const newURL = newBaseURL + fileName;
      anchor.setAttribute('href', newURL);
    }
  });
});


